module.exports = __webpack_public_path__ + "static/img/coin.12eadcb9.png";